import { css } from 'styled-components';

const focusShadow = /*#__PURE__*/css(["box-shadow:", ";"], ({
  theme: {
    focusVisible: {
      boxShadowBlurRadius,
      boxShadowSpreadRadius,
      boxShadowColor
    }
  }
}) => `0 0 ${boxShadowBlurRadius} ${boxShadowSpreadRadius} ${boxShadowColor}`);
var focusShadow$1 = focusShadow;

export { focusShadow$1 as f };
//# sourceMappingURL=focusShadow-4fdc6b22.js.map
